export const quoteSteps = {
  client: 0,
  assets: 1,
  financeProduct: 2,
  dataCompletion: 3,
  contract: 4,
};

export const zootDocDecisionColor = {
  green: "Green",
  blue: "Blue",
  red: "Red",
};
